// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3SUtI","content":"LoadingAlert_content__18OXL"};